Page accountPage
	title = "Mein Account"
	needsAuth = true
	
	ValidationState	validationState = {}
	bool	isLoading
	bool	resetEmailSent
	bool	showGeneralTerms, showBusinessTerms
	UserType	confirmedUserType
	bool	showConfirmation = false

	show: string id = ""
		validationState.clear
		isLoading = false
		html.setTitle title + app.titleSuffix
		showGeneralTerms = not app.user.generalTermsAccepted
		showBusinessTerms = not app.user.businessTermsAccepted	
		showConfirmation = false

	draw
		if not app.user then return
		div marginTop:20px
			app.box
				div width:100%, display:flex, flexDirection:column, gap:16
					div tag:"h1", text:"Mein Konto"
					if showConfirmation
						div text:app.getText(confirmedUserType == Business ? "confirmBusiness" : "confirmSeller") border:{1px solid primaryColor}, borderRadius:8, padding:{top:16 bottom:16 left:16 right:16}, marginBottom:32px
						
					// Account Type Section
					form.radioGroup model:app.user.claimedUserType, required:true
						options:["PrivateSeller", "BusinessSeller", "Business"]
						optionLabels:["Ich bin Privatverkäufer", "Ich bin gewerblicher Verkäufer", "Ich bin Händler"]
						flexDirection:isMobile ? column : row
						gap:isMobile ? 16 : 32
					
					// Contact Data Section
					div gap:16 display:flex flexDirection:isMobile ? column : row
						form.dropdown label:"Anrede", model:app.user.anrede, required:false, options:["Frau", "Herr", "Keine Angabe"] width:170px
						form.text label:"Vorname", model:app.user.firstName, minTextLength:2, maxTextLength:50, required:true, validationState, focusInitially:true
						form.text label:"Nachname", model:app.user.lastName, minTextLength:2, maxTextLength:50, required:true, validationState
					if app.user.claimedUserType == BusinessSeller or app.user.claimedUserType == Business
						form.text label:"Firmenname", model:app.user.businessName, width:100%, minTextLength:2, maxTextLength:100, required:true, validationState
					
					// Address Section
					form.text label:"Straße", model:app.user.streetAddress, width:100%, minTextLength:5, maxTextLength:100, required:true, validationState
					row gap:16
						form.text label:"Postleitzahl", model:app.user.zipCode, width:35%, minTextLength:4, maxTextLength:10, required:true, validationState
						form.text label:"Stadt", model:app.user.city, width:80%, minTextLength:2, maxTextLength:50, required:true, validationState
					form.text label:"Land", model:app.user.country, width:100%, minTextLength:2, maxTextLength:50, required:true, validationState
					
					// Phone Number
					form.text label:"Telefonnummer", model:app.user.phoneNumber, width:100%, minTextLength:5, maxTextLength:20, required:true, validationState
					
					// Terms
					if showGeneralTerms
						form.toggle model: app.user.generalTermsAccepted, label:app.getText("generalTerms"), required:true, validationState
					if showBusinessTerms and app.user.claimedUserType == Business
						form.toggle model: app.user.businessTermsAccepted, label:app.getText("businessTerms"), required:true, validationState

					// Business Documents
					if app.user.claimedUserType == Business
						let label = "documents"
						let container = column gap:8
							for app.user.documents as document
								row alignItems:center gap:16
									div "📎&nbsp;&nbsp;{document}"
									div "✕" color:#ef4444 cursor:pointer fontSize:20 lineHeight:1
										onClick: await backend.users.removeFile app.user.documents, document
							html.fileInput multiple:true accept:".jpg,.jpeg,.png,.webp,.pdf" capture:none
								div width:128px height:128px border:{2px solid primaryColor} borderRadius:8 display:flex flexDirection:column alignItems:center justifyContent:center gap:8
									img Add width:48px
									div "Gewerbeschein hochladen" fontSize:12 color:#6b7280 textAlign:center
							onChange:
								await backend.users.addFiles app.user.documents, .files
									onError: alert delay:100, "Die folgenden Dateien konnten nicht hochgeladen werden:\n{.joinToString.name separator:"\n"}\n\nBitte prüfen Sie, ob die Datei ein gültiges JPEG, PNG oder PDF und nicht größer als 10 MB ist. Falls das Problem erneut auftritt, wenden Sie sich bitte an den Support."
							if backend.users.busy
								row alignItems:center marginTop:8 gap:4
									img ProgressA, width:40
									div "Wird hochgeladen..."
							if validationState.shouldValidate(label)
								if not app.user.documents then	validationState[label] = "Bitte laden Sie Ihren Gewerbeschein hoch."
								else	validationState[label] = ""
							form.showErrorMessage validationState[label]
						container.set "class", validationState[label] ? "validation-error" : ""
					
					// Save Button			
					div margin:{top:32}, display:flex, flexDirection:column
						app.button text:"Speichern", isDisabled:isLoading, triggerWithEnterKey:true
							onClick:
								if validationState.checkForErrorsOrEmptyFields then return
								isLoading = true
								refresh
								
								try
									let name = app.user.firstName
									if app.user.lastName then	name += " " + app.user.lastName
									if app.user.businessName then	name += ", " + app.user.businessName
									dynamic update = {app.user.claimedUserType, app.user.anrede, name, app.user.firstName, app.user.lastName, app.user.businessName, app.user.phoneNumber, app.user.streetAddress, app.user.zipCode, app.user.city, app.user.country, app.user.generalTermsAccepted, app.user.businessTermsAccepted}
									if app.user.claimedUserType == PrivateSeller or app.user.claimedUserType == BusinessSeller
										update.userType = app.user.claimedUserType
									await backend.users.update app.user, update
									
									// Send new user message to admins if not already sent
									if not app.user.newUserMessageSent
										try
											await backend.post "/api/new-user", {}
											app.user.newUserMessageSent = true
										catch as error
											print type:Error "Error sending new user message:", error
									
									isLoading = false
									validationState.clear
									showConfirmation = true
									confirmedUserType = app.user.claimedUserType
									refresh
									html.scrollToTop
								catch as error
									isLoading = false
									print type:Error "Error updating user:", error
									refresh

				column margin:{top:32}
					if resetEmailSent
						div text:"E-Mail zum Ändern des Passworts versendet! Bitte prüfen Sie Ihr Postfach.", fontSize:14, textAlign:center
					else
						div text:"Passwort ändern", textDecoration:underline, cursor:pointer
							onClick:
								isLoading = true
								refresh
								try
									await backend.pb.collection('users').requestPasswordReset(app.user.email)
									resetEmailSent = true
								catch as error
									print type:Error "Error resetting password", error
								isLoading = false
								refresh
					// div "Abmelden", textDecoration:underline, cursor:pointer, onClick:app.logout
